import AdsError from './AdsError.js'

export default class GetSearchRequestObjectFromUrlError extends AdsError {}
